import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { loadSharedTranslations } from '../utils/translationLoader';

i18n.use(initReactI18next).init({
  fallbackLng: 'es',
  debug: true,
  resources: {},
});

loadSharedTranslations('es');
